_ = require 'underscore'
Auth = require 'db/auth'
debounceSignal = require 'lib/util/debounce-signal'
Hearsay = require 'hearsay'

signalCache = {}

pluginsChangedSignal = (board, card) ->
  snooper = board.snoopIdPluginsEnabled()
  .map (idPlugins) ->
    if idPlugins.length == 0
      return Hearsay.const {}

    snoopers = idPlugins.map (idPlugin) ->
      if card
        Hearsay.combine Auth.me().snoopPluginData(idPlugin), board.snoopPluginData(idPlugin), card.snoopPluginData(idPlugin)
      else
        Hearsay.combine Auth.me().snoopPluginData(idPlugin), board.snoopPluginData(idPlugin)

    Hearsay.combine snoopers...
    .map (latestPluginData) ->
      _.object(idPlugins, latestPluginData)
  .latest()

  signal = snooper.distinct(_.isEqual)

  debouncedSignal = debounceSignal signal
  debouncedSignal.use()
  debouncedSignal

module.exports = (board, card) ->
  if card
    signalCache[board.id + card.cid] ?= pluginsChangedSignal(board, card)
  else
    signalCache[board.id] ?= pluginsChangedSignal(board)



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugins-changed-signal.coffee